import { DEMO_LS_KEY, DEMO_ENABLED_LS_KEY, LAST_ACTIVITY_KEY } from './readDemoProfile';

export function clearDemoState() {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    localStorage.removeItem(DEMO_ENABLED_LS_KEY);
    localStorage.removeItem(DEMO_LS_KEY);
    localStorage.removeItem(LAST_ACTIVITY_KEY);
    // Collect before removing — mutating .key(i) mid-iteration shifts indexes.
    const logoKeys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith('demo:brandLogo:')) logoKeys.push(k);
    }
    logoKeys.forEach(k => localStorage.removeItem(k));
  } catch { /* ignore */ }
}
